import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { findById } from "../../../api/getNews"

function RecipeDetails() {
  const location = useLocation()
  const [recipe, setRecipe] = useState({})
  const { search } = location

  useEffect(() => {
    const id = search.slice(1)
    console.log(Number(id))
    setRecipe(findById(Number(id)))
  }, [search])

  return (
    <div style={{ width: "100%", height: "calc(100vh - 100px)" }}>
      <div
        style={{
          backgroundImage: `url('${recipe.image}')`,
          width: "100%",
          height: 240,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          display: "flex",
          flexDirection: "column-reverse",
        }}
      ></div>
      <p style={{ paddingLeft: 16, paddingRight: 16, paddingTop: 24 }}>
        Ингредиенты:
      </p>
      {recipe.ingredients?.map((item) => {
        return (
          <div
            key={item}
            style={{ paddingLeft: 16, paddingRight: 16, paddingTop: 0 }}
          >
            <p style={{ padding: 0 }}>{item}</p>
          </div>
        )
      })}
      {recipe.steps?.map((item) => {
        return (
          <div
            key={item.step}
            style={{ paddingLeft: 16, paddingRight: 16, paddingTop: 24 }}
          >
            <p>{item.step}</p>
            <p>{item.description}</p>
          </div>
        )
      })}
    </div>
  )
}

export default RecipeDetails
